import { Option } from '../../../ts/interface/components/table.interface';
import { ISystem } from '../../../ts/interface/system.interface';
import useSystemOrganization from '../query/organization/useSystemOrganization';

function useSystemList(organization_id: string) {
  const { data } = useSystemOrganization(
    {},
    {
      organization_id: organization_id,
    }
  );

  const systemList =
    (data?.systems.map((item: ISystem) => ({
      label: item.name,
      value: item.gid,
    })) as Option[]) || [];

  return { systemList, systemData: data?.systems };
}

export default useSystemList;
